import './SwiperButtons.css'
import { GrNext, GrPrevious } from "react-icons/gr";

function SwiperButtons({ swiperRef }) {

    const handlePrev = () => {
        if (swiperRef?.current) swiperRef.current.slidePrev();
    };

    const handleNext = () => {
        if (swiperRef?.current) swiperRef.current.slideNext();
    };

    return (
        <div className="swiperBtns">
            <button onClick={handlePrev}><GrPrevious size='25px' /></button>
            <button onClick={handleNext}><GrNext size='25px' /></button>
        </div>
    )
}

export default SwiperButtons






// we use this hooks and function at next lines for moving between articles go forward and back.
    // and also react icons for giving style and shape to our btns.
